import styled from 'styled-components';

export const ContainerChoosePayment = styled.div`
  display: flex;
  flex-direction: column;
  width: 89.333vw;
`;

export const BackArrowIcon = styled.img`
  width: 3.733vw;
  height: 3.733vw;
  position: absolute;
  left: 4.5vw;
  top: 3.5vw;
  padding: 0 3vw 0 3vw;
`;

export const TextTitle = styled.h1`
  font-size: 5.56vw;
  font-family: 'Libre Franklin', sans-serif;
  font-weight: bold;
  margin-top: 5.3vw;
`;

export const TextSubTitle = styled.p`
  font-size: 3.7vw;
  font-family: 'Libre Franklin', sans-serif;
  margin-top: 2.6vw;
  margin-bottom: 5.3vw;
`;

export const ButtonSelectPayment = styled.button<{ bottomMargin: string }>`
  display: flex;
  flex-direction: row;
  height: 13vw;
  border-radius: 2.6vw;
  border: 1px solid #c7c7c7;
  background-color: white;
  align-items: center;
  gap: 1.8vw;
  margin-bottom: ${(props) => props.bottomMargin};
`;

export const IconCreditCard = styled.img`
  height: 4.2vw;
  width: 5.4vw;
  margin-left: 4.2vw;
`;

export const IconPix = styled.img`
  height: 4.2vw;
  width: 5.4vw;
  margin-left: 4.2vw;
`;

export const TitleMethod = styled.span`
  font-size: 4.2vw;
  font-family: 'Libre Franklin', sans-serif;
  color: #000000;
`;
